<script>import { getContext, onMount, tick } from "svelte";
import { TIPTAP_NODE_VIEW } from "./context";
const { onDragStart } = getContext(TIPTAP_NODE_VIEW);
let element;
export let as = "div";
onMount(async () => {
  await tick();
  element.style.whiteSpace = "normal";
});
</script>

<svelte:element
  this={as}
  bind:this={element}
  data-node-view-wrapper=""
  on:dragstart={onDragStart}
  role="none"
  {...$$restProps}
>
  <slot />
</svelte:element>
